import { useMemo } from 'react';

import { getRelativeValue } from 'src/components/dashboard/DashboardPage/helper';
import type { GaugeData } from 'src/components/dashboard/DashboardPage/widgets/NpsGaugeWidget/hooks';
import type { AggregateList } from 'src/components/followUp/common/types';

import { extractNpsData } from '../helper';

interface UseNpsScoreCalculationParams {
  data: AggregateList | undefined;
}

interface UseNpsScoreCalculationReturn {
  npsScores?: GaugeData;
}

const useNpsScoreCalculation = ({
  data,
}: UseNpsScoreCalculationParams): UseNpsScoreCalculationReturn => {
  const npsScores = useMemo(() => {
    if (!data) {
      return undefined;
    }

    const extractedData = extractNpsData(data);
    const { promoters, passives, detractors, totalScore } = extractedData;

    return {
      promoters: getRelativeValue(promoters, data.totalObjects, 0),
      passives: getRelativeValue(passives, data.totalObjects, 0),
      detractors: getRelativeValue(detractors, data.totalObjects, 0),
      totalScore,
    };
  }, [data]);

  return { npsScores };
};

export default useNpsScoreCalculation;
